import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ArticleColorUsp from "../article-color-usp/article-color-usp-component"
import ReactHtmlParser from "react-html-parser"

const ArticleTextUsp = ({ topPadding, topText, bottomText, uspBlock }) => {
  const resolvedTopPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding)

  return (
    <div className={`article-text-usp ${resolvedTopPadding || ""}`}>
      <div className="w--wider">
        <div className="top-text rich-text">{ReactHtmlParser(topText)}</div>
        <ArticleColorUsp {...uspBlock} />
        <div className="bottom-text rich-text">{ReactHtmlParser(bottomText)}</div>
        <div className="clear"></div>
      </div>
    </div>
  )
}

export default ArticleTextUsp
